import React from 'react';
import Link from '@material-ui/core/Link';
import t from 'prop-types';

const TelLinkCell = ({value}) => <Link href={`tel:${value}`}>{value}</Link>;
TelLinkCell.propTypes = {
  value: t.string,
};

export default TelLinkCell;
